import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-info__items" }
const _hoisted_2 = { style: {"display":"flex","width":"100%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"5px 16px 0 0"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 请选择开户银行 ")
], -1)

import { computed, watchEffect } from 'vue';
import {
  BaseFormItem,
  BaseRadio,
  BaseRadioGroup,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { FY_CHANNEL } from '../../constants';
import infoStore from '../../store/info';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-fy',
  setup(__props) {

const { formData } = storeToRefs(infoStore());

const tipsDay = computed(() => {
  return formData.value.fyChannel === '01' ? '1' : '1-2';
});

watchEffect(() => {
  if (formData.value.fyChannel !== '01') {
    !formData.value.fyBeneficiaryInfoList.length &&
      (formData.value.fyBeneficiaryInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          address: null,
          portraitFilePath: null,
          badgeFilePath: null,
          beneficiaryType: null
        }
      ]);
    !formData.value.fyShareholderInfoList.length &&
      (formData.value.fyShareholderInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          portraitFilePath: null,
          badgeFilePath: null
        }
      ]);
  } else {
    formData.value.fyBeneficiaryInfoList = [];
    formData.value.fyShareholderInfoList = [];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode(" 富友支付开户银行 ")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), { style: {"display":"flex","flex-direction":"column","padding-top":"0"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(BaseFormItem), {
            prop: "fyChannel",
            rules: [
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ],
            style: {"margin-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseRadioGroup), {
                modelValue: _unref(formData).fyChannel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).fyChannel) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FY_CHANNEL), (item) => {
                    return (_openBlock(), _createBlock(_unref(BaseRadio), {
                      key: item.value,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, "预计开户时间：" + _toDisplayString(tipsDay.value) + "个工作日，实际以银行审核结果为准", 1)
      ]),
      _: 1
    })
  ]))
}
}

})